import { render } from "./ReadIndicator.vue?vue&type=template&id=16dfd1ed&scoped=true"
import script from "./ReadIndicator.vue?vue&type=script&lang=js"
export * from "./ReadIndicator.vue?vue&type=script&lang=js"

import "./ReadIndicator.vue?vue&type=style&index=0&id=16dfd1ed&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dfd1ed"]])

export default __exports__